export default __webpack_public_path__ + "d9749dca9b06c53b83a6b9e34c11844e.png";